import { FuelButton } from '@frete.com/fuel-react';
import actions from 'constants/reducers';
import { useAppContext } from 'hooks/useAppContext';
import { usePayPerUseExtraTruckers } from 'hooks/usePayPerUseExtraTruckers';
import { useUnlockSuggestedTruckersEvents } from 'hooks/useUnlockSuggestedTruckersEvents';
import React from 'react';
import { brlCurrencyFormatter } from 'utils/brlCurrencyFormatter';

const UnlockTruckersButton = () => {
  const {
    state: {
      truckers: { meta },
    },
    dispatch,
  } = useAppContext();
  const { sendUnlockSuggestedTruckersEvent } = useUnlockSuggestedTruckersEvents();
  const { freeAvailable, price } = usePayPerUseExtraTruckers();

  const hasConsumed = meta?.extrasTruckers?.hasConsumed;

  const handleOpenModal = () => dispatch({ type: actions.modals.setOpenPurchaseExtraSuggestedTruckers });

  const handleUnlockTruckers = () => {
    sendUnlockSuggestedTruckersEvent('button-open-modal');
    handleOpenModal();
  };

  const getButtonLabelText = () => {
    if (freeAvailable > 0) {
      return 'Desbloquear motoristas';
    }
    return `Desbloquear motoristas por ${brlCurrencyFormatter(price)}`;
  };

  return (
    <FuelButton
      size="medium"
      trailingIcon={hasConsumed ? 'unlock' : 'lock'}
      trailingIconStyle="filled"
      onClick={handleUnlockTruckers}
      disabled={hasConsumed}
    >
      {getButtonLabelText()}
    </FuelButton>
  );
};

export default UnlockTruckersButton;
